import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { InputDataEditSessionUrl } from '../InputDataEditSessionUrl';

interface UpdateInputDataDraftsRequest {
  sessionId: string;
  rows: { rowId: number; payload: unknown }[];
}

const updateInputDataDrafts = async ({
  sessionId,
  rows,
}: UpdateInputDataDraftsRequest): Promise<void> => {
  await apiClient.patch(expand(InputDataEditSessionUrl.rows, { sessionId }), {
    drafts: rows.map((row) => ({ ...row, op: 'UPDATE' })),
  });
};

export const useUpdateInputDataDraftsMutation = createApiMutationHook<
  UpdateInputDataDraftsRequest,
  void
>(['input-data-drafts-update'], updateInputDataDrafts);
